import { c as _c } from "react/compiler-runtime";
import { CheckboxRow, Flexbox, Input, Text } from '@newfront-insurance/core-ui';
import type { NumberOrCheckboxInputMetadata } from '@newfront-insurance/coverage-api';
import { getStringifiedFieldValue } from '@newfront-insurance/dsl-schema-ui';
import type { SchemaInputControlCustomInputProps, CustomValue } from '@newfront-insurance/dsl-schema-ui';
import type { JSX } from 'react';
export type NumberOrCheckboxInputValue = Record<string, number | boolean | undefined> | undefined;
export function NumberOrCheckboxDslInput(t0) {
  const $ = _c(20);
  const {
    onChange,
    value,
    metadata
  } = t0;
  if (!metadata) {
    return null;
  }
  const checkboxValue = value?.[metadata.checkboxFieldName] || false;
  let t1;
  if ($[0] !== checkboxValue || $[1] !== metadata || $[2] !== onChange || $[3] !== value) {
    t1 = function handleNumberChange(stringValue) {
      if (!metadata) {
        return;
      }
      if (!stringValue && !checkboxValue) {
        onChange(undefined);
        return;
      }
      onChange({
        ...value,
        [metadata.numberFieldName]: Number(stringValue),
        [metadata.checkboxFieldName]: checkboxValue || false
      });
    };
    $[0] = checkboxValue;
    $[1] = metadata;
    $[2] = onChange;
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleNumberChange = t1;
  let t2;
  if ($[5] !== metadata || $[6] !== onChange) {
    t2 = function handleCheckboxChange(isActive) {
      if (!metadata) {
        return;
      }
      if (!isActive) {
        onChange(undefined);
        return;
      }
      onChange({
        [metadata.checkboxFieldName]: isActive
      });
    };
    $[5] = metadata;
    $[6] = onChange;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleCheckboxChange = t2;
  const t3 = metadata?.appendText;
  const t4 = value?.[metadata.numberFieldName] as number ?? "";
  const t5 = !!checkboxValue;
  let t6;
  if ($[8] !== handleNumberChange || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <Input type="number" appendText={t3} value={t4} onChange={handleNumberChange} disabled={t5} />;
    $[8] = handleNumberChange;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = metadata?.checkboxFieldLabel ?? "";
  const t8 = !!checkboxValue;
  let t9;
  if ($[13] !== handleCheckboxChange || $[14] !== t7 || $[15] !== t8) {
    t9 = <CheckboxRow label={t7} isActive={t8} onClick={handleCheckboxChange} />;
    $[13] = handleCheckboxChange;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t9) {
    t10 = <Flexbox flexDirection="column" gap={8} marginTop="auto">{t6}{t9}</Flexbox>;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}

// eslint-disable-next-line react/function-component-definition
export const NumberOrCheckboxDisplay: CustomValue<NumberOrCheckboxInputValue, NumberOrCheckboxInputMetadata> = t0 => {
  const $ = _c(5);
  const {
    field,
    value
  } = t0;
  let t1;
  if ($[0] !== field || $[1] !== value) {
    t1 = getStringifiedFieldValue(value, field);
    $[0] = field;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Text>{t1}</Text>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};